<div class="container-areas">
    
    <div class="container-areas__header">
        <div class="column top">
            <h1 class="container-areas__header__title">
                {{ 'labels.areas' | translate | titlecase }}
            </h1>
            <button (click)="onClickClose()" class="container-areas__header__close"></button>
        </div>
        <div class="column bottom">
            <div class="search-box">
                <i class="pi pi-search icon"></i>
                <input 
                    type="text" 
                    pInputText
                    [placeholder]="'labels.search' | translate | titlecase"
                    [(ngModel)]="searchValue"
                    (ngModelChange)="onChangeSearchValue$.next($event)"
                />
            </div>
        </div>
    </div>

    <div class="container-areas__content">

        <div *ngIf="isErrorMax500AreasVisible" class="container-areas__content__max-selected-areas-error">
            <i class="pi pi-info-circle icon"></i>
            <span>
                {{ 'areas.max-selected-areas' | translate }}
            </span>
        </div>

        <div
            *ngIf="!isLoadingGroups && !groups.length && !untaggedAreas.length"
            class="container-areas__content__empty-state"
        >
            <img src="/assets/img/areas/empty-state-areas.svg" alt="empty state img">

            <span class="container-areas__content__empty-state__title">
                {{ 'areas.no-defined-areas' | translate }}
            </span>
            <span class="container-areas__content__empty-state__desc">
                {{ 'areas.click-btn-below' | translate }}
            </span>
        </div>

        <ng-container *ngIf="isLoadingGroups">
            <div class="container-areas__content__skeleton">
                <p-skeleton *ngFor="let item of [1,1,1,1,1,1,1,1,1,1,1]" height="5rem"></p-skeleton>
            </div>
        </ng-container>

        <div 
            *ngIf="!isLoadingGroups && (groups.length || untaggedAreas.length)"
            class="container-areas__content__list"
        >
            <p-accordion
                #accordion
                [multiple]="true"
                (tabOpen)="onToggleAccordion($event, accordion)"
                [activeIndex]="activeGroups"
                class="container-areas__content__list__accordion"
            >
                <p-accordion-panel *ngFor="let item of groups; let index = index; trackBy: trackByGroups" [value]="index">
                    <p-accordion-header>
                        <ng-template #toggleicon let-active="active">
                            <button (click)="onToggleAccordion($event, accordion, index)" class="accordion-icon">
                                @if (active) {
                                    <i class="pi pi-angle-down"></i>
                                } @else {
                                    <i class="pi pi-angle-right"></i>
                                }
                            </button>
                        </ng-template>

                        <div class="group-header">
                            <p-progressSpinner
                                *ngIf="item.isLoadingAreas"
                                strokeWidth="3"
                                [style]="{ width: '20px', height: '20px'}"
                            ></p-progressSpinner>

                            <p-checkbox
                                [(ngModel)]="item.isChecked"
                                (ngModelChange)="onToggleAllGroupAreasInMap(item, index)"
                                [binary]="true"
                                [disabled]="item.isLoadingAreas"
                                inputId="binary-{{ index }}"
                            ></p-checkbox>
                            <label
                                [title]="item.tag.L"
                                class="group-header__label"
                                for="binary-{{ index }}"
                            >
                                {{ item.tag.L }}
                            </label>
                        </div>
                    </p-accordion-header>

                    <p-accordion-content>
                        <div class="group-list">
                            <ng-container *ngIf="!item.isLoadingAreas">
                                <app-area-item-list
                                    *ngFor="let area of item.areas; let areaIndex = index; trackBy: trackByAreas"
                                    (ngModelChange)="onChangeCheckedStateArea($event, area, item.tag.Id)"
                                    (onEdit$)="onEditArea($event)"
                                    (onDelete$)="deleteAreaInGroup($event, item.tag.Id, areaIndex)"
                                    [(ngModel)]="area.isChecked"
                                    [data]="area"
                                ></app-area-item-list>
                            </ng-container>
                        </div>
                    </p-accordion-content>
                </p-accordion-panel>
            </p-accordion>
            <div class="container-areas__content__list__untagged-areas">
                <app-area-item-list
                    *ngFor="let area of untaggedAreas; trackBy: trackByAreas"
                    (ngModelChange)="onChangeCheckedStateUntaggedArea($event, area)"
                    (onEdit$)="onEditArea($event)"
                    (onDelete$)="deleteUntaggedArea($event)"
                    [(ngModel)]="area.isChecked"
                    [data]="area"
                ></app-area-item-list>
            </div>
        </div>
    </div>

    <button (click)="addArea$.emit()" class="container-areas__add-area">
        <p-button [label]="'map.new-area' | translate"></p-button>
    </button>
</div>
